import Edit from "features/Accountant/CodManagement/Edit";
import React from "react";

const CodManagementEdit = () => {
  return <Edit />;
};

export default CodManagementEdit;
